import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { MapperTypeCompanyLevel } from 'entities/MapperType';
import React from "react";
import { Pagination, ReferenceManyField, usePermissions, useTranslate } from 'react-admin';
import { CustomerCompaniesMappersList } from 'resources/customer-companies/CustomerCompaniesMappers';

import { CompanyManagerRoles } from "../../entities";
import { TabPanel } from "./TabPanel";
import { CompanyServiceSettingsTab, CompanySettingsTab, Notifications } from ".";

const useStyles = makeStyles(() => ({
	tabs: {
		borderBottom: '1px solid #e0e0e0', 
	}
}));
  
export const CompanySettings = (props) => {
    const { permissions } = usePermissions();
	const translate = useTranslate();
	const isCompanyManager = permissions && CompanyManagerRoles.indexOf(permissions.role) !== -1;
	const classes = useStyles();

	const [value, setValue] = React.useState(0);
  
	const handleChange = (event, newValue) => {
	  setValue(newValue);
	};

	return (
		isCompanyManager ? <>
		  <Tabs
			value={value}
			onChange={handleChange}
			indicatorColor="primary"
			textColor="primary"
			className={classes.tabs} 
		  >
			<Tab label={translate("tab.notifications.name")} />
			<Tab label={translate("tab.company_settings.name")}/>
			<Tab label={translate("tab.company_service_settings.name")}/>
			<Tab label={translate("tab.mapper.name")}/>
		  </Tabs>
		
		  <TabPanel value={value} index={0}>
			<Notifications {...props} />
		  </TabPanel>
		  <TabPanel value={value} index={1}>
		  	<CompanySettingsTab {...props}/>
		  </TabPanel>
		  <TabPanel value={value} index={2}>
		  	<CompanyServiceSettingsTab {...props}/>
		  </TabPanel>
		  <TabPanel value={value} index={3}>
		  		<ReferenceManyField label={false} fullWidth reference="mappers" filter={{"company_id": permissions.company_id, "type": MapperTypeCompanyLevel.order_import}}
										pagination={<Pagination rowsPerPageOptions={[5, 10, 15, 20, 25]} />} perPage={5}>
					<CustomerCompaniesMappersList id={permissions.company_id} defaultValue={MapperTypeCompanyLevel.order_import} {...props}/>
				</ReferenceManyField>
		  </TabPanel>
	  </> : <></>
	  );
};
